var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMailOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.969,
    height: 15.175,
    viewBox: "0 0 18.969 15.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-mail-orange",
    d: "M4.9,11.691v7.587H20.072V11.691l-7.587,2.845ZM4.9,7.9v1.9l7.587,2.845,7.587-2.845V7.9ZM4.9,6H20.072a1.9,1.9,0,0,1,1.9,1.9V19.278a1.9,1.9,0,0,1-1.9,1.9H4.9a1.9,1.9,0,0,1-1.9-1.9V7.9A1.9,1.9,0,0,1,4.9,6Z",
    transform: "translate(-3 -6)",
    fill: "#f39628"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailOrange);
export default __webpack_public_path__ + "static/media/icon-mail-orange.d4aae12bf794d7e11c93b513aae65ba8.svg";
export { ForwardRef as ReactComponent };